import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@material-ui/core';
import ProductDescription from './ProductDescription';
import ProductImage from '../ProductImage';
import ButtonContainer from '../ButtonContainer';
import Tracking from '../tracking/Tracking';
import { defineBillImageByCountry } from '../../../../../helpers/orders/OrdersHelper';
import { useProductDetailDesktopStyles } from './styles';

const ProductDetailDesktop = ({ ...props }) => {
  const {
    thumbnailImage,
    purchaseState,
    sku,
    orderId,
    quantity,
    isMkp,
    billImage,
    dispatch,
    errorTracking,
    source,
    urlNc,
    totalPrice,
    name,
    purchaseDate,
  } = props;
  const classes = useProductDetailDesktopStyles();
  const [trackingOpen, setTrackingOpen] = useState(false);

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box className={classes.container}>
        <ProductImage
          src={thumbnailImage}
          purchaseState={purchaseState}
          sku={sku}
        />
        <Box display="flex" flexDirection="column">
          <ProductDescription sku={sku} orderId={orderId} quantity={quantity} />
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            disableElevation
            onClick={() => setTrackingOpen(!trackingOpen)}
            data-cy="trackingButtonDesktop"
          >
            Seguir mi compra
          </Button>
        </Box>
        <ButtonContainer
          thumbnailImage={thumbnailImage}
          name={name}
          orderId={orderId}
          totalPrice={totalPrice}
          quantity={quantity}
          purchaseDate={purchaseDate}
          isMkp={isMkp}
          billImage={defineBillImageByCountry(billImage, orderId, source)}
          urlNc={urlNc}
          sku={sku}
          source={source}
        />
      </Box>
      <React.Fragment>
        {trackingOpen && (
          <Tracking
            handleTracking={() => setTrackingOpen(!trackingOpen)}
            dispatch={dispatch}
            orderId={orderId}
            errorTracking={errorTracking}
          />
        )}
      </React.Fragment>
    </Box>
  );
};

ProductDetailDesktop.propTypes = {
  thumbnailImage: PropTypes.string,
  purchaseState: PropTypes.string,
  sku: PropTypes.string,
  orderId: PropTypes.number,
  quantity: PropTypes.number,
  isMkp: PropTypes.bool,
  billImage: PropTypes.string,
  dispatch: PropTypes.object,
  errorTracking: PropTypes.string,
  source: PropTypes.string,
  urlNc: PropTypes.string,
  totalPrice: PropTypes.number,
  name: PropTypes.string,
  purchaseDate: PropTypes.string,
};

export default ProductDetailDesktop;
